import { render, staticRenderFns } from "./brand-remote-select.vue?vue&type=template&id=68aeb8cf"
import script from "./brand-remote-select.vue?vue&type=script&lang=js"
export * from "./brand-remote-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports